module.exports = __webpack_public_path__ + "static/media/product-pic.84e237ad.png";